import { render } from "./TattooModal.vue?vue&type=template&id=e70db900&scoped=true"
import script from "./TattooModal.vue?vue&type=script&lang=js"
export * from "./TattooModal.vue?vue&type=script&lang=js"

import "./TattooModal.vue?vue&type=style&index=0&id=e70db900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70db900"]])

export default __exports__